import { render, staticRenderFns } from "./Affaire.vue?vue&type=template&id=0108d80d&"
import script from "./Affaire.vue?vue&type=script&lang=js&"
export * from "./Affaire.vue?vue&type=script&lang=js&"
import style0 from "./Affaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports